// layout/MainLayout.jsx
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Outlet } from "react-router-dom";

const MainLayout = ({ hideHeader }) => {
    return (
        <div id="page">

 {!hideHeader && <Header />}

           	<main class="pattern">
                <Outlet />
            </main>
           {!hideHeader && <Footer />}
        </div>
    );
};

export default MainLayout;